import { Helpers } from '../../helpers';
import { IChangeRequest } from '../../interfaces/ichange-request';
import { ChangeRequestStatus } from '../change-request-status';
import { ChangeRequestWell } from '../change-request-well';
import { ScenarioChangeRequest } from '../scenario-change-request';

export class ChangeRequestBase {
  ChangeRequestId: number;
  Name: string | null;
  ChangeRequestStatusId: number | null;
  AuthorUID: string | null;
  ProposedChange: string | null;
  Justification: string | null;
  ChangeImpact: string | null;
  NatureOfChange: string | null;
  DateCreated: Date | null;
  DateApproved: Date | null;
  CreatedForUID: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ChangeRequestWells_ChangeRequest?: Array<ChangeRequestWell> | null;
  ScenarioChangeRequests_ChangeRequest?: Array<ScenarioChangeRequest> | null;
  ChangeRequestStatus?: ChangeRequestStatus;

  constructor(item?: IChangeRequest) {
    if (item) {

      this.ChangeRequestId = item.ChangeRequestId;
      this.Name = item.Name;
      this.ChangeRequestStatusId = item.ChangeRequestStatusId;
      this.AuthorUID = item.AuthorUID;
      this.ProposedChange = item.ProposedChange;
      this.Justification = item.Justification;
      this.ChangeImpact = item.ChangeImpact;
      this.NatureOfChange = item.NatureOfChange;
      this.DateCreated = item.DateCreated ? new Date(item.DateCreated) : null;
      this.DateApproved = item.DateApproved ? new Date(item.DateApproved) : null;
      this.CreatedForUID = item.CreatedForUID;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ChangeRequestWells_ChangeRequest = Helpers.createClassArray(ChangeRequestWell, item.ChangeRequestWells_ChangeRequest);
      this.ScenarioChangeRequests_ChangeRequest = Helpers.createClassArray(ScenarioChangeRequest, item.ScenarioChangeRequests_ChangeRequest);
      this.ChangeRequestStatus = new ChangeRequestStatus(item.ChangeRequestStatus);
    }
  }
}